import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'containers/App/actions';
import { ChecklistComponent } from 'components/NCCheckList/Checklist';

const LeadTaskList = ({ data }) => {
  const [activeTaskIndex, setActiveTask] = useState(-1);
  const dispatch = useDispatch();
  let leads = JSON.parse(JSON.stringify(data));
  leads = Array.isArray(leads) ? leads: Object.values(leads);

  const fullProjects = leads
    ?.filter(project => project.tasks?.length > 0)
    .sort((item1, item2) => item1.name?.localeCompare(item2.name));
  const emptyProjects = leads
    ?.filter(project => !project.tasks?.length)
    .sort((item1, item2) => item1.name?.localeCompare(item2.name));
  leads = fullProjects.concat(emptyProjects);

  const { createNotificationTask } = bindActionCreators(actions, dispatch);

  const createTask = (leadId, tasks) => {
    const variables = {
      module: 'leads',
      leadId,
      input: {},
      referenceId: tasks.length > 0 ? tasks[0].id : null,
    };

    if (variables) {
      createNotificationTask({ variables });
      setActiveTask(0);
    }
  };

  return (
    <>
      {leads?.map(({ id, name, tasks, assignmentOptions }) => (
        <div
          name="checklist"
          key={id}
        >
          <div name="headers">
            <div name="controls">
              <button
                className="APIconButton"
                name="add"
                onClick={() => createTask(id, tasks)}
              >
                +
              </button>
            </div>
            <h2
              name="name"
              className="heading-section"
            >
              LEAD / {name?.toUpperCase()}
            </h2>
            {!tasks.length && (
              <div name="empty">You have no assigned tasks for this lead.</div>
            )}
          </div>
          <ChecklistComponent
            tasks={tasks}
            leadId={id}
            assignmentOptions={assignmentOptions}
            module="leads"
            active={activeTaskIndex}
            setActive={setActiveTask}
          />
        </div>
      ))}
    </>
  );
};

export default LeadTaskList;
